import React, { forwardRef, useEffect, useState } from "react";
import "./erf_Printout.scss";

const DeliveryChallanPrintout = forwardRef((props, ref) => {
  const [data, setData] = useState({});

  useEffect(() => {
    setData(props?.data || {});
  }, [props]);

  // Reusable total qty calculator
  const calcTotalQty = (items) =>
    Array.isArray(items)
      ? items.reduce((acc, item) => acc + Number(item?.orderedQuantity || 0), 0)
      : 0;

  // Reusable product table — returns null if no items
  const ItemTable = ({ title, items }) => {
    if (!Array.isArray(items) || items.length === 0) return null;

    return (
      <>
        <div className="section-title">{title}</div>
        <div className="table-responsive">
          <table className="table table-bordered table-hover">
            <thead>
              <tr>
                <th>Sr. No.</th>
                <th>P.Code</th>
                <th>Product Name</th>
                <th>Barcode</th>
                <th>HSN/SAC</th>
                <th>Qty.</th>
                <th>Unit</th>
              </tr>
            </thead>
            <tbody>
              {items.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item?.materialCode || "—"}</td>
                  <td>{item?.materialDescription || "—"}</td>
                  <td>{item?.barcode || "—"}</td>
                  <td>{item?.hsnCode || "—"}</td>
                  <td>{item?.orderedQuantity || 0}</td>
                  <td>{item?.orderUnitOfMeasure || "—"}</td>
                </tr>
              ))}
              <tr className="total-row">
                <td colSpan="5" className="text-end">
                  <strong>Total</strong>
                </td>
                <td>
                  <strong>{calcTotalQty(items)}</strong>
                </td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
      </>
    );
  };

  // True if at least one item type has data
  const hasAnyItems =
    data?.rentItems?.length > 0 ||
    data?.saleItems?.length > 0 ||
    data?.nursingItems?.length > 0 ||
    data?.serviceItems?.length > 0;

  return (
    <>
      <div ref={ref} className="deliverychallancontainer">
        <div className="delivery-challan">

          {/* Header Image */}
          <div className="row">
            <div className="col-12">
              <img
                src="/assets/img/medirent/printoutimage/deliverychallan.png"
                alt="Medical Equipment Header"
                className="img"
              />
            </div>
          </div>

          {/* Document Title */}
          <div className="document-title text-center">DELIVERY CHALLAN</div>

          {/* Party Info */}
          <div className="section-title">Delivery Challan for :</div>
          <div className="party-info">
            <div className="row mb-2">
              <div className="col-sm-3 info-label">Party Name :</div>
              <div className="col-sm-9">
                <strong>{data?.patientName || "—"}</strong>
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-sm-3 info-label">Address :</div>
              <div className="col-sm-9">
                <strong>
                  {[
                    data?.deliveryAddress,
                    data?.deliveryState,
                    data?.deliveryPinCode,
                    data?.mobileNr ? `MOB - ${data.mobileNr}` : null,
                  ]
                    .filter(Boolean)
                    .join(", ") || "—"}
                </strong>
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-sm-3 info-label">Phone :</div>
              <div className="col-sm-9">
                <strong>{data?.mobileNr || "—"}</strong>
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-sm-3 info-label">Email :</div>
              <div className="col-sm-9">
                <strong>{data?.email || "—"}</strong>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-3 info-label">GSTIN :</div>
              <div className="col-sm-9">
                <strong>{data?.gstNo || "—"}</strong>
              </div>
            </div>
          </div>

          {/* Product Details section — only if any items exist */}
          {hasAnyItems && (
            <div className="section-title">Product Details</div>
          )}

          {/* Each table renders only if that item array has data */}
          <ItemTable title="Rent Items" items={data?.rentItems} />
          <ItemTable title="Sale Items" items={data?.saleItems} />
          <ItemTable title="Nursing Items" items={data?.nursingItems} />
          <ItemTable title="Service Items" items={data?.serviceItems} />

          {/* Fallback when no items at all */}
          {!hasAnyItems && (
            <div className="text-center my-3">No items found.</div>
          )}

          {/* Terms */}
          <div className="section-title">Terms and Conditions</div>
          <div className="mb-4">Received above items in fully quantity.</div>

          {/* Signatures */}
          <div className="signature-section">
            <div className="row">
              <div className="col-md-6">
                <div>
                  <strong>For MEDIRENT SERVICE PVT. LTD.</strong>
                </div>
                <div className="footer-note">(Signature)</div>
                <div className="signature-box"></div>
              </div>
              <div className="col-md-6">
                <div>
                  <strong>Received By :</strong>
                </div>
                {/* patientName is the receiver */}
                <div className="mb-2">Name : {data?.patientName || "......"}</div>
                {/* dispatchDate from dispatchDetails[0] */}
                <div className="mb-2">
                  Date :{" "}
                  {data?.dispatchDetails?.[0]?.dispatchDate || "....../....../......"}
                </div>
              </div>
            </div>

            <div className="row mt-4">
              <div className="col-md-6">
                <div>
                  <strong>Delivered By :</strong>
                </div>
                {/* driverName from dispatchDetails[0] */}
                <div className="mb-2">
                  Name : {data?.dispatchDetails?.[0]?.driverName || "......"}
                </div>
                <div>Signature</div>
                <div className="signature-box"></div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </>
  );
});

export default DeliveryChallanPrintout;
